import React, { useEffect, useState } from "react";
import throttle from "lodash/throttle";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import axios from "../../utils/axiosInstance"; 
import "./withdraw.css";
import Swal from "sweetalert2";
import ApproveModal from "./ApproveModal";
import WithdrawAction from "./WithdrawAction";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import { MailOutline } from "@material-ui/icons";
import CardBody from "components/Card/CardBody";
import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import CustomInput from "components/CustomInput/CustomInput";
import { useParams } from "react-router-dom";
import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { blackColor } from "assets/jss/material-dashboard-pro-react";
import { formatUTCToLocal } from "utils/timezone";
import mervIcon from "assets/mervIcon.svg";
import dollorIcon from "assets/yellow-t.svg";
import { CircularProgress } from "@mui/material";
const useStyleData = makeStyles(stylesData);
const useStyles = makeStyles(styles);
const UserTransactionList = (props) => {
  const [value, setValue] = useState("")
  console.log(value, "value")
  const [loading, setLoading] = useState(false);
  const searchParams = new URLSearchParams(window.location.search);
  const userId = searchParams.get("userId");
  const { userID } = props;
  const [transactionsData, setTransactionsData] = useState([]);
  const [formValues, setFormValues] = React.useState({
    firstName: "",
    lastName: "",
    nickName: " ",
    email: "",
    mobileNumber: "",
    city: "",
    address: "",
    country: "",
    ZipCode: "",
    status: "",
    userType: "",
    dob: ""
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const countPerPage = 10;

  const [walletBalance, setWalletBalance] = React.useState({})
  const [g2fBalance , setG2fBalance]=React.useState()

  console.log( walletBalance.walletAmount, "g2fBalance") 
  const mockData = [
    {
      transactionId: "TXN001",
      ticketNumber: "TKT123",
      LotteryName: "Mega Jackpot",
      amount: "100 USDT",
      surpriceAmt: "10 USDT",
      lotteryStatus: "Won",
      winAmount: "500 USDT",
      createdDate: "2025-04-10",
    },
    {
      transactionId: "TXN002",
      ticketNumber: "TKT456",
      LotteryName: "Mini Draw",
      amount: "50 USDT",
      surpriceAmt: "5 USDT",
      lotteryStatus: "Lost",
      winAmount: "0 USDT",
      createdDate: "2025-04-09",
    },
    {
      transactionId: "TXN003",
      ticketNumber: "TKT789",
      LotteryName: "Super Spin",
      amount: "75 USDT",
      surpriceAmt: "8 USDT",
      lotteryStatus: "Pending",
      winAmount: "-",
      createdDate: "2025-04-08",
    },
    // Add more mock entries as needed
  ];

  const filteredData = mockData.filter(item =>
    item.ticketNumber.toLowerCase().includes(value.toLowerCase())
  );






  const classes = useStyles();
  useEffect(() => {
    getData();
    getUserwalletBalance();
    G2fBalance()
  }, []);

  useEffect(() => {
    getTransactionData(currentPage);

  }, [currentPage, value]);


  const getData = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/getendusersid?id=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );

      if (response?.data?.data) {
        setFormValues(response.data.data);
      }

    } catch (err) {
      console.log("Error fetching user details:", err);
    } finally {
      setLoading(false);
    }
  };

  const getUserwalletBalance = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/user-wallet-balance?userId=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      if (response?.data?.data) {
        setWalletBalance(response.data.data);
      }
    } catch (err) {
      console.log("Error fetching user details:", err);
    } finally {
      setLoading(false);
    }
  }
    const G2fBalance = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/user-G2f-balance?userId=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      if (response?.data?.data) {
        setG2fBalance(response.data.data);
      }
    } catch (err) {
      console.log("Error fetching user details:", err);
    } finally {
      setLoading(false);
    }
  }

  const getTransactionData = async (pageNumber = 1) => {
    const token = localStorage.getItem("token");
    const limit = countPerPage;
    const search = "";

    try {
      setLoading(true);

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/user-transaction`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
          params: {
            userId,
            pageNumber,
            limit,
            search: value,
          },
        }
      );

      if (response?.data?.data) {
        setTransactionsData(response.data.data);
        setTotalRecords(response.data.data.totalItems || 0);
      }

    } catch (err) {
      console.error("Error fetching user transactions:", err);
    } finally {
      setLoading(false);
    }
  };
  const updatePage = (page) => {
    setCurrentPage(page);
  };

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>View User</h4>

          </CardHeader>
          <CardBody>
            <form>
              <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="First Name"
                    id="firstName"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      type: "text",
                      disabled: true,
                      value: formValues.firstName || "",
                    }}
                  />
                </GridItem>

                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Last Name"
                    id="lastName"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      type: "text",
                      disabled: true,
                      value: formValues.lastName || "",
                    }}
                  />
                </GridItem>

                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Nick Name"
                    id="nickName"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      type: "text",
                      disabled: true,
                      value: formValues.nickName || "",
                    }}
                  />
                </GridItem>

                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Email Id"
                    id="email"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      type: "text",
                      disabled: true,
                      value: formValues.email || "",
                    }}
                  />
                </GridItem>

                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Contact Number"
                    id="mobileNumber"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      type: "number",
                      disabled: true,
                      value: formValues.mobileNumber || "",
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3} style={{ marginTop: "12px" }}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="DOB"
                      value={formValues.dob}
                      disabled
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          disabled
                          InputProps={{
                            ...params.InputProps,
                            style: { color: blackColor || "#000" },
                          }}
                          InputLabelProps={{
                            style: { color: blackColor || "#000" },
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Country"
                    id="country"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      type: "text",
                      disabled: true,
                      value: formValues.country || "",
                    }}
                  />
                </GridItem>

                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="State"
                    id="state"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      type: "text",
                      disabled: true,
                      value: formValues.state || "",
                    }}
                  />
                </GridItem>

                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="City"
                    id="city"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      type: "text",
                      disabled: true,
                      value: formValues.city || "",
                    }}
                  />
                </GridItem>

                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Address"
                    id="address"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      type: "text",
                      disabled: true,
                      value: formValues.address || "",
                    }}
                  />
                </GridItem>

                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Zip Code"
                    id="ZipCode"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      type: "text",
                      disabled: true,
                      value: formValues.ZipCode || "",
                    }}
                  />
                </GridItem>



                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Status"
                    id="status"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: "text",
                      value: formValues.status ? "Active" : "InActive",
                      readOnly: true,
                      disabled: true,
                    }}
                  />



                </GridItem>
              </GridContainer>


            </form>
          </CardBody>
        </Card>

      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <div style={{ width: "100%" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
              width: "100%",
              flexWrap: "wrap",
            }}
          >

            <div class="winnings-header">

              <div class="winnings-values">
                <div class="winnings-item">
                  <img src={mervIcon} alt="MERV" />
                  <span>{g2fBalance}</span>
                </div>
                <div class="winnings-item">
                  <img src={dollorIcon} alt="USDT" />
                  <span class="gold-text">{walletBalance.walletAmount}</span>
                </div>
              </div>
            </div>

            <div>
              <input
                placeholder="Search by Ticket Number"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                className="search"
                style={{
                  borderRadius: "5px",
                  border: "1px solid black",
                  height: "28px",
                  padding: "0 10px",
                }}
              />
            </div>
          </div>
        </div>

        {loading ? (
          <div className="table-t1">
            <div style={{ textAlign: "center", padding: "2rem" }}>
              <CircularProgress color="secondary" />
            </div>
          </div>
        ) : (
          <>
            {transactionsData?.transactions?.length > 0 ? (
              <div className="table-t1">
                <form>
                  <table style={{ borderCollapse: "collapse", width: "100%" }}>
                    <thead>
                      <tr className="table-th">
                        <th>Transaction Id</th>
                        <th>Ticket Number</th>
                        <th>Lottery Name</th>
                        <th>Ticket Price</th>
                        {/* <th>Surprice Amount</th> */}
                        <th>Win Amount</th>
                        <th>Created Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transactionsData.transactions.map((item, i) => (
                        <tr key={i} className="table-th2">
                          <td>{item._id}</td>
                          <td>{item.ticketNumber}</td>
                          <td>{item.lotteryName}</td>
                          <td>{item.price}</td>
                          {/* <td>{item.surpriceAmt}</td> */}
                          <td>{item.lotteryWinningPrize}</td>
                          <td>{formatUTCToLocal(item.createdAt)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </form>
              </div>
            ) : (
              <div className="table-t1">
                <div style={{ textAlign: "center", padding: "2rem" }}>
                  <p>No transactions found.</p>
                </div>
              </div>
            )}
          </>

        )}



        {value === "" && (
          <Pagination
            pageSize={countPerPage}
            onChange={updatePage}
            current={currentPage}
            total={totalRecords}
            className="justify-content-end"
          />
        )}
      </GridItem>
    </GridContainer>

  );
};
export default UserTransactionList;
